import { ApiType } from "@gymflow/common";
import { TokenPageableRequestParams } from "@gymflow/types";
import { useInfiniteQuery } from "@tanstack/react-query";

import { memberAsMemberQueryKeys } from "./memberAsMemberQueryKeys";

export function useInfiniteQueryMemberInvoiceListNewAsMember(
  {
    api,
    params,
  }: {
    api: ApiType;
    params: TokenPageableRequestParams;
  },
  { enabled }: { enabled?: boolean } = {},
) {
  return useInfiniteQuery({
    queryKey: memberAsMemberQueryKeys.invoicesNew(params),
    queryFn: async ({ pageParam }: { pageParam?: string }) => {
      return (
        await api.profileApi.findInvoicesNew({
          ...params,
          nextPageToken: pageParam,
        })
      ).data;
    },
    getNextPageParam: (lastPage) => lastPage?.nextPageToken,
    enabled,
    initialPageParam: undefined,
  });
}
